import * as yup from 'yup';
import {
	firstStep,
	projects,
	environments,
	thirdStep,
	secondStep,
	fourthStep,
	editProject,
} from '../core/messages/en';
import {
	EH_ENV_NAME_VALIDATION_PATTERN,
	ENVIRONMENT_NAME_VALIDATION_PATTERN,
} from '../utils/constants';

const { requiredName } = projects;
const { maxCharacters } = firstStep;
const {
	requiredEnvironmentName,
	invalidEnvironmentName,
	invalidEhEnvironmentName,
	requiredEhEnv,
} = environments;
const { maxCharacters: envMaxCharacters } = thirdStep;
const {
	repoRequired,
	orgRequired,
	projectNameRequired,
	repositoryNameValidationMessage,
} = secondStep;
const { requriedCmEnv } = fourthStep;
const { forbiddenChars, cannotEndWith } = editProject;

const notRequired = () => yup.string().notRequired();

const handleName = () =>
	yup
		.string()
		.required(requiredName)
		.max(100, maxCharacters)
		.testForbidChars(forbiddenChars)
		.endsWithForbidChars(cannotEndWith);

const validateRepository = (isRequired: boolean) =>
	isRequired
		? yup
				.string()
				.required(repoRequired)
				.matches(
					/^[A-Za-z0-9_.-]{1,100}$/,
					repositoryNameValidationMessage,
				)
		: notRequired();

const validateAdoProjectName = (isRequired: boolean) =>
	isRequired ? yup.string().required(projectNameRequired) : notRequired();

const validateAdoOrganization = (isRequired: boolean) =>
	isRequired ? yup.string().required(orgRequired) : notRequired();

const validateEnvironment = (isEhEnv = false) =>
	yup
		.string()
		.required(isEhEnv ? requiredEhEnv : requiredEnvironmentName)
		.max(100, envMaxCharacters)
		.matches(
			new RegExp(
				isEhEnv
					? EH_ENV_NAME_VALIDATION_PATTERN
					: ENVIRONMENT_NAME_VALIDATION_PATTERN,
			),
			isEhEnv ? invalidEhEnvironmentName : invalidEnvironmentName,
		);

export const createProjectValidationSchema = ({
	providers,
	isByoc,
	enableCreateProjectV3,
}: {
	providers: {
		isAdoProvider: boolean;
		isCmAdoProvider: boolean;
		isEhAdoProvider: boolean;
	};
	isByoc: boolean;
	enableCreateProjectV3: boolean;
}) =>
	enableCreateProjectV3
		? yup.object({
				name: handleName(),
				repository: validateRepository(!isByoc),
				cmRepository: validateRepository(isByoc),
				ehRepository: validateRepository(isByoc),
				cmAdoProjectName: validateAdoProjectName(
					providers.isCmAdoProvider && isByoc,
				),
				ehAdoProjectName: validateAdoProjectName(
					providers.isEhAdoProvider && isByoc,
				),
				cmAdoOrganization: validateAdoOrganization(
					providers.isCmAdoProvider && isByoc,
				),
				ehAdoOrganization: validateAdoOrganization(
					providers.isEhAdoProvider && isByoc,
				),
				cmEnvironmentName: validateEnvironment(),
				ehEnvironmentName: validateEnvironment(true),
				cmEnvironmentId: yup.string().required(requriedCmEnv),
			})
		: yup.object({
				name: handleName(),
				repository: validateRepository(true),
				adoProjectName: validateAdoProjectName(providers.isAdoProvider),
				adoOrganization: validateAdoOrganization(
					providers.isAdoProvider,
				),
				environmentName: validateEnvironment(),
			});
